import React, { VFC } from 'react';
import Profile from './Profile';
import { PROFILES } from '~/src/feature/Ambassador/constants';

interface Props {}

const Profiles: VFC<Props> = () => {
  return (
    <>
      {PROFILES.map((profile) => (
        <Profile key={profile.name} {...profile} />
      ))}
    </>
  );
};

export default Profiles;
